module.exports = __webpack_public_path__ + "static/donation-749785972ec5c968cb177b2c510182bf.jpg";